import { useAppBrand } from '@shared/lib/app-brand'
import { show404 } from '@shared/lib/page-error'

import { defineNuxtRouteMiddleware, navigateTo } from '#app'

export default defineNuxtRouteMiddleware((to) => {
  const { isSmartestMinds } = useAppBrand()

  if (isSmartestMinds) return navigateTo('/')

  if (!Number(to.params.summarize)) return show404()
})
